//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { TableHead as MuiTableHead, TableRow as MuiTableRow } from '@mui/material';

const TableHead = ({ children, className = '', ...props }) => {
  return (
    <MuiTableHead className={className} {...props}>
      <MuiTableRow>{children}</MuiTableRow>
    </MuiTableHead>
  );
};

export default TableHead;
